import logo from "@/assets/Guestly_Logo_Mark.svg";

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo = ({ className = "", width = 144, height = 48 }: LogoProps) => {
  return (
    <img 
      src={logo} 
      alt="Guestly Homes - Professional Corporate Housing and Furnished Apartments for Business Travel" 
      className={`brightness-0 invert animate-fade-in ${className}`}
      width={width}
      height={height}
    />
  );
};

export default Logo;
